module.exports = __webpack_public_path__ + "img/br42.c2425e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br42.jpg
// module id = tADK
// module chunks = 0